import { render, staticRenderFns } from "./BandejaFechaCantidadDiasTranscurridoComponente.vue?vue&type=template&id=7c1c86a0&scoped=true"
import script from "./BandejaFechaCantidadDiasTranscurridoComponente.vue?vue&type=script&lang=js"
export * from "./BandejaFechaCantidadDiasTranscurridoComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c86a0",
  null
  
)

export default component.exports